const IMAGES = {
  hero_abstract:
    "https://images.unsplash.com/photo-1758520145408-dedb359d1c49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxzbWFsbCUyMG9mZmljZSUyMHRlYW0lMjBkYXJrJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkxOTA0ODAyfDA&ixlib=rb-4.1.0&q=85",
  server_rack:
    "https://images.unsplash.com/photo-1603201667141-5a2d4c673378?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMHRlYW0lMjBsYXB0b3BzJTIwb2ZmaWNlfGVufDB8fHx8MTc5MTkwNDgwMnww&ixlib=rb-4.1.0&q=85",
  cybersecurity:
    "https://images.unsplash.com/photo-1689848693914-7ba25d9f3334?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB0YWxraW5nJTIwb24lMjBwaG9uZSUyMG9mZmljZXxlbnwwfHx8fDE3OTE5MDQ4MDJ8MA&ixlib=rb-4.1.0&q=85",
  office_team:
    "https://images.unsplash.com/photo-1603201667230-bd139210db18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxzbWFsbCUyMHRlYW0lMjBtZWV0aW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc5MTkwNDgwMXww&ixlib=rb-4.1.0&q=85",
  office_phone:
    "https://images.unsplash.com/photo-1586996157503-9587db867a20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjB0YWxraW5nJTIwb24lMjBwaG9uZSUyMG9mZmljZXxlbnwwfHx8fDE3OTE5MDQ4MDJ8MA&ixlib=rb-4.1.0&q=85",
  managed_it_corporate:
    "https://images.pexels.com/photos/1181316/pexels-photo-1181316.jpeg?auto=compress&cs=tinysrgb&w=1200",
  backup_dr_corporate:
    "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const SERVICES = [
  {
    slug: "managed-it-services",
    icon: "Server",
    name: "Managed IT Services",
    short: "Your entire IT environment — monitored, patched and planned around the clock.",
    metaTitle: "Managed IT Services for Small Business | Sempresera",
    metaDescription:
      "24/7 monitoring, automated patching, vendor management and a dedicated virtual CIO. Managed IT services for US small businesses, one all-inclusive standard.",
    image: IMAGES.managed_it_corporate,
    imageAlt: "An IT engineer monitoring servers in a modern server room",
    intro:
      "Most small businesses run their IT on hope: hope the server holds, hope the backup ran, hope nobody clicks the wrong link. Sempresera replaces hope with an operating standard — the same discipline large corporations take for granted, sized for teams of one to twenty-five.",
    included: [
      "24/7 remote monitoring & alerting (MSP360 RMM)",
      "Automated patch management",
      "Vendor management — we deal with your providers",
      "Network & firewall management",
      "On-site support across New England (emergency dispatch elsewhere in the US)",
      "Hardware lifecycle planning",
      "Quarterly business reviews",
      "IT budgeting & roadmap",
      "Security strategy & policy reviews",
      "Dedicated virtual CIO",
    ],
    faqs: [
      {
        q: "Do you support businesses outside New England?",
        a: "Yes. Sempresera serves small businesses anywhere in the United States. New England clients receive full service including on-site visits; everywhere else is remote-first, with on-site dispatch reserved for genuine emergencies.",
      },
      {
        q: "What does 24/7 monitoring actually do?",
        a: "Every device reports health, patch status and performance to our platform around the clock. When something drifts — a failing disk, a missed patch, unusual resource use — our team is alerted and acts before it becomes your problem.",
      },
      {
        q: "Will we have a dedicated point of contact?",
        a: "Yes. Every client gets a named account manager and a dedicated virtual CIO who knows your environment, joins your quarterly business reviews, and owns your IT roadmap and budget.",
      },
    ],
  },
  {
    slug: "cybersecurity",
    icon: "ShieldCheck",
    name: "Cybersecurity",
    short: "Huntress-powered security with a 24/7 human-led SOC watching over your business.",
    metaTitle: "Cybersecurity for Small Business — Huntress Partner | Sempresera",
    metaDescription:
      "Managed EDR, identity protection for Microsoft 365, SIEM and security awareness training — Huntress-powered cybersecurity built for US small businesses.",
    image: IMAGES.cybersecurity,
    imageAlt: "A professional working at a desk with a computer and phone",
    intro:
      "Attackers figured out long ago that small businesses hold valuable data and rarely have anyone watching. Sempresera puts a 24/7 human-led security operations center behind your business — the same Huntress platform trusted to protect organizations many times your size.",
    included: [
      "Managed EDR with 24/7 human-led SOC threat hunting & response (Huntress)",
      "Managed ITDR protecting Microsoft 365 identities against credential theft, account takeover and business email compromise (Huntress)",
      "Managed SIEM — log correlation & retention (Huntress)",
      "Security awareness training with phishing simulations",
      "Dark-web monitoring for exposed credentials",
      "Vulnerability management",
      "Compliance support (HIPAA)",
      "Incident response planning",
    ],
    faqs: [
      {
        q: "What is Managed EDR?",
        a: "Endpoint Detection and Response watches every workstation and server for malicious behavior. Huntress pairs that telemetry with a 24/7 human-led security operations center that investigates alerts, hunts for hidden threats and isolates compromised devices — so attacks are stopped by people, not just software.",
      },
      {
        q: "Can you help us meet HIPAA requirements?",
        a: "Yes. We support HIPAA compliance programs for small practices and firms — risk-aware configuration of Microsoft 365, access controls, logging, awareness training and documentation support aligned to the security rule.",
      },
      {
        q: "What happens when a threat is found?",
        a: "The Huntress SOC investigates and can isolate the affected device immediately, day or night. Our team then handles remediation with you and folds the lessons into your security awareness training and incident response plan.",
      },
    ],
  },
  {
    slug: "cloud-microsoft-365",
    icon: "Cloud",
    name: "Cloud & Microsoft 365",
    short: "Exchange, Teams, SharePoint and OneDrive — administered, secured and optimized.",
    metaTitle: "Microsoft 365 Support for Small Business | Sempresera",
    metaDescription:
      "Full Microsoft 365 administration: Exchange, Teams, SharePoint, OneDrive, Entra ID, conditional access, licensing and migrations — for US small businesses.",
    image: IMAGES.hero_abstract,
    imageAlt: "A small team working together in a modern office with computers",
    intro:
      "Microsoft 365 runs most small businesses — yet most tenants are barely configured, over-licensed and under-secured. Sempresera runs your cloud like it matters: hardened, right-sized and quietly maintained so your team just works.",
    included: [
      "Full Exchange, Teams, SharePoint & OneDrive administration",
      "User onboarding & offboarding",
      "License management & cost optimization",
      "Conditional access policies",
      "Entra ID (Azure AD) management",
      "Cloud migrations",
      "Tenant governance & configuration standards",
    ],
    faqs: [
      {
        q: "Can you migrate us to Microsoft 365?",
        a: "Yes. We plan and execute migrations from on-premises Exchange, Google Workspace and legacy file servers — email, files and calendars — with a cutover plan that keeps your team working.",
      },
      {
        q: "Do you manage our licenses?",
        a: "Yes. We right-size your Microsoft 365 licensing, reclaim unused seats and review spend regularly, so you only pay for what your team actually uses.",
      },
      {
        q: "How do you secure our Microsoft 365 tenant?",
        a: "Through Entra ID management and conditional access policies — strong sign-in rules, device requirements and location-aware access — layered with Huntress Managed ITDR to catch credential theft and account takeover.",
      },
    ],
  },
  {
    slug: "help-desk-support",
    icon: "Headset",
    name: "Help Desk Support",
    short: "A 24/7/365 help desk that answers — by phone or email.",
    metaTitle: "24/7 Help Desk Support for Small Business | Sempresera",
    metaDescription:
      "Round-the-clock IT help desk for US small businesses: phone and email support with a 15-minute critical response target and a named account manager.",
    image: IMAGES.office_phone,
    imageAlt: "A professional at a desk helping a client by phone",
    intro:
      "When something breaks at 7am before a client meeting, a ticket queue isn't support — a person who picks up is. Sempresera's help desk is staffed around the clock, every day of the year, with a 15-minute response target for critical issues.",
    included: [
      "24/7/365 support by phone or email — unlimited, never capped",
      "Your assigned engineer's direct cell once you transition over",
      "15-minute critical response target",
      "Named account manager",
      "Remote resolution first — most issues fixed in minutes",
      "On-site dispatch across New England (emergency dispatch elsewhere in the US)",
      "Escalation to senior engineers, not a script",
    ],
    faqs: [
      {
        q: "How fast do you respond?",
        a: "Critical issues — systems down, security events, anything stopping the business — carry a 15-minute response target, any hour of any day. Routine requests are handled promptly within the same day.",
      },
      {
        q: "How do we reach the help desk?",
        a: "By phone or email — whichever your team prefers. Every customer is also assigned their own engineer, whose cell number you get once you transition to Sempresera. Every request is tracked so nothing gets lost.",
      },
      {
        q: "Do you come on site?",
        a: "In New England, on-site support is part of the standard service. Elsewhere in the US we are remote-first, and we dispatch on-site help for genuine emergencies.",
      },
    ],
  },
  {
    slug: "backup-disaster-recovery",
    icon: "DatabaseBackup",
    name: "Backup & Disaster Recovery",
    short: "Immutable, tested backups and a recovery plan you can actually execute.",
    metaTitle: "Backup & Disaster Recovery for Small Business | Sempresera",
    metaDescription:
      "MSP360-powered immutable backups, Microsoft 365 cloud-to-cloud backup, quarterly restore testing and documented disaster recovery for US small businesses.",
    image: IMAGES.backup_dr_corporate,
    imageAlt: "Server racks in a modern data center",
    intro:
      "A backup nobody has tested is a rumor. Sempresera protects your data with immutable, ransomware-proof copies — including everything inside Microsoft 365 — and proves recovery works with quarterly restore tests and an annual disaster recovery drill.",
    included: [
      "Automated daily cloud backup (MSP360 Managed Backup)",
      "Cloud-to-cloud Microsoft 365 backup — Exchange, OneDrive, SharePoint, Teams, contacts & calendars",
      "Immutable, ransomware-proof backups with object lock",
      "Item-level & point-in-time recovery",
      "Quarterly restore testing",
      "Documented disaster recovery plan",
      "Annual DR drill",
      "Business continuity planning",
    ],
    faqs: [
      {
        q: "Are backups protected against ransomware?",
        a: "Yes. Backups are immutable with object lock — once written, they cannot be altered or deleted during the retention period, even by an attacker who compromises your network or credentials.",
      },
      {
        q: "Is our Microsoft 365 data really backed up?",
        a: "Yes. Microsoft's shared responsibility model does not include backup of your data. We run cloud-to-cloud backup of Exchange, OneDrive, SharePoint, Teams, contacts and calendars with item-level and point-in-time recovery.",
      },
      {
        q: "Do you test that restores actually work?",
        a: "Every quarter we perform restore tests and report the results, and once a year we run a full disaster recovery drill against your documented DR plan.",
      },
    ],
  },
];

export { IMAGES };
